<mat-list>
  <ng-container *ngIf="displaySettings$ | async as displaySettings">
    <mat-list-item>
      <div
        class="frame warning"
        mat-line
        *ngIf="!params.newsday && params.scoreevent && checkTimeframe()"
        matTooltip="This event drives the score over a longer period than your selected timeframe, so its articles are shown from the whole scoring window."
      >
        <span>Full score window</span>
      </div>
    </mat-list-item>
    <mat-list-item
      *ngFor="let news of newsfeed; index as index"
      [class]="'news-feed-news-item-' + params.newstype"
    >
      <div
        class="frame"
        mat-line
        *ngIf="news.time && !news.hidden && !(newstype === 'Relevant')"
      >
        <mat-icon class="flip">update</mat-icon>
        <span>{{ news.time }}</span>
        <span class="time-zone-info">(Time Zone: GMT)</span>
      </div>
      <div
        mat-line
        *ngIf="!news.hidden"
        class="bloksent box-map"
        [class.recommended]="news.recommendation"
        [class.resolved]="
          displaySettings.dimResolved &&
          params.newstype === 'Flagged' &&
          news.resolved &&
          news.resolved === 'Resolved'
        "
        [class.seen]="
          displaySettings.fadeoutSeen &&
          userActivityApi.seenArticles &&
          userActivityApi.seenArticles.includes(news.id) &&
          params.newstype !== 'Flagged' &&
          params.newstype !== 'Dismissed'
        "
        [class.inew]="news.inew"
        [matTooltipDisabled]="
          (screenSize$ | async)?.isMobile || routing.isIframe() || fullscreen
        "
        [matTooltip]="getTeaser(news)"
        matTooltipPosition="right"
        matTooltipShowDelay="200"
        matTooltipClass="newstooltip"
        (mouseenter)="onMouseEnterRow(news)"
        (mouseleave)="onMouseLeaveRow(news)"
      >
        <div class="news-container">
          <div class="cont" (click)="selectNews(news, 'feednews')">
            <div class="border" *ngIf="news.sentiment_proportions">
              <div
                *ngIf="featureFlagsService.showArticleSentiment"
                class="bar pos"
                [style.height]="news.sentiment_proportions.pos | percent"
              ></div>
              <div
                *ngIf="featureFlagsService.showArticleSentiment"
                class="bar neu"
                [style.height]="news.sentiment_proportions.neu | percent"
              ></div>
              <div
                *ngIf="featureFlagsService.showArticleSentiment"
                class="bar neg"
                [style.height]="news.sentiment_proportions.neg | percent"
              ></div>
            </div>
            <div class="tito" [class.blur]="news.reduce_visibility">
              <div
                mat-line
                [attr.lang]="news.lang || null"
                [innerHTML]="news.titleFormatted | sanitizeHtml"
              ></div>
            </div>
            <div class="subo" mat-line>
              <div class="blok">
                <span
                  >{{
                    news.publish_time | date: 'dd.MM.yyyy HH:mm' : 'GMT'
                  }}
                  GMT</span
                >
              </div>
              <div class="blok">
                <span> | </span>
              </div>
              <div class="blok blok2" *ngIf="news.provider">
                <span class="notranslate">{{ news.provider }}</span>
              </div>
              <ng-container
                *ngIf="
                  params.newstype === 'Events' &&
                  news.events &&
                  news.events.length > 0 &&
                  (news.events[0].temporality || news.events[0].factuality)
                "
              >
                <div class="blok blok2">
                  <span>
                    {{
                      news.events[0].temporality === 'UNKNOWN' ||
                      news.events[0].temporality === 'NONE'
                        ? 'PRESENT,'
                        : news.events[0].temporality
                          ? news.events[0].temporality + ','
                          : ''
                    }}
                  </span>

                  <span
                    *ngIf="
                      ['FACT', 'COUNTERFACT'].includes(
                        news.events[0].factuality
                      )
                    "
                    >FACT
                  </span>
                  <span
                    *ngIf="
                      ['PROBABLE', 'COUNTERPROBABLE'].includes(
                        news.events[0].factuality
                      )
                    "
                    >PROBABLE</span
                  >
                  <span
                    *ngIf="
                      ['POSSIBLE', 'COUNTERPOSSIBLE'].includes(
                        news.events[0].factuality
                      )
                    "
                    >POSSIBLE</span
                  >
                </div>
              </ng-container>
              <div
                class="blok icon"
                *ngIf="
                  news.document_categorization &&
                  news.document_categorization.is_licensed_content
                "
                matTooltip="Licensed content with fulltext"
              >
                <img
                  *ngIf="routing.theme !== 'light'"
                  src="assets/logo/yukka_mobile.svg"
                />
                <img
                  *ngIf="routing.theme === 'light'"
                  src="assets/logo/yukka_mobile_light.svg"
                />
              </div>
            </div>
          </div>
          <ng-container *ngIf="!(screenSize$ | async)?.isMobile">
            <div
              class="audit-info"
              *ngIf="
                routing.isNewsaudit() &&
                !(
                  params.newstype === 'Flagged' ||
                  params.newstype === 'Dismissed'
                )
              "
            >
              <div class="audit-info-events">
                <button
                  class="no-action"
                  mat-button
                  [matMenuTriggerFor]="menuAuditEvents"
                  #menuTriggerEvents="matMenuTrigger"
                  (mouseenter)="onMouseEnter(menuTriggerEvents, 'button')"
                  (mouseleave)="onMouseLeave(menuTriggerEvents, 'button')"
                >
                  <span mat-line
                    >{{ news.auditEvents ? news.auditEvents[0] : ''
                    }}{{
                      news.auditEvents && news.auditEvents.length > 1
                        ? ' +' + (news.auditEvents.length - 1)
                        : ''
                    }}</span
                  >
                </button>
                <mat-menu #menuAuditEvents="matMenu" overlapTrigger="true">
                  <div
                    (mouseenter)="onMouseEnter(menuTriggerEvents, 'menu')"
                    (mouseleave)="onMouseLeave(menuTriggerEvents, 'menu')"
                  >
                    <button
                      class="no-action"
                      mat-menu-item
                      *ngFor="let event of news.auditEvents"
                    >
                      {{ event }}
                    </button>
                  </div>
                </mat-menu>
              </div>
              <div class="audit-info-entities">
                <button
                  class="no-action"
                  mat-button
                  [matMenuTriggerFor]="menuAuditEntities"
                  #menuTriggerEntities="matMenuTrigger"
                  (mouseenter)="onMouseEnter(menuTriggerEntities, 'button')"
                  (mouseleave)="onMouseLeave(menuTriggerEntities, 'button')"
                >
                  <span [class.hidden]="params.tag" mat-line
                    >{{ news.auditParticipants ? news.auditParticipants[0] : ''
                    }}{{
                      news.auditParticipants &&
                      news.auditParticipants.length > 1
                        ? ' +' + (news.auditParticipants.length - 1)
                        : ''
                    }}</span
                  >
                </button>
                <mat-menu #menuAuditEntities="matMenu" overlapTrigger="true">
                  <div
                    (mouseenter)="onMouseEnter(menuTriggerEntities, 'menu')"
                    (mouseleave)="onMouseLeave(menuTriggerEntities, 'menu')"
                  >
                    <button
                      class="no-action"
                      mat-menu-item
                      *ngFor="let entity of news.auditParticipants"
                    >
                      {{ entity }}
                    </button>
                  </div>
                </mat-menu>
              </div>
            </div>
            <div
              class="audit-info"
              *ngIf="
                routing.isNewsaudit() &&
                (params.newstype === 'Flagged' ||
                  params.newstype === 'Dismissed')
              "
            >
              <div
                class="audit-info-events"
                *ngIf="params.newstype === 'Flagged'"
              >
                <button class="no-action" mat-button>
                  <span
                    mat-line
                    matTooltipPosition="above"
                    matTooltip="{{ news.resolved + ' (' }}{{
                      (news.timestamp | date: 'dd.MM.yyyy HH:mm' : 'GMT') + ')'
                    }}"
                    >{{ news.resolved + ' ('
                    }}{{
                      (news.timestamp | date: 'dd.MM.yyyy HH:mm' : 'GMT') + ')'
                    }}</span
                  >
                </button>
              </div>
              <div
                class="audit-info-events"
                *ngIf="params.newstype === 'Dismissed'"
              >
                <button class="no-action" mat-button>
                  <span
                    mat-line
                    matTooltipPosition="above"
                    matTooltip="{{
                      'Dismissed (' +
                        (news.timestamp | date: 'dd.MM.yyyy HH:mm' : 'GMT') +
                        ')'
                    }}"
                    >{{
                      'Dismissed (' +
                        (news.timestamp | date: 'dd.MM.yyyy HH:mm' : 'GMT') +
                        ')'
                    }}</span
                  >
                </button>
              </div>
              <div class="audit-info-entities">
                <button
                  class="no-action"
                  mat-button
                  [matMenuTriggerFor]="menuAuditSubjects"
                  #menuTriggerSubjects="matMenuTrigger"
                  (mouseenter)="onMouseEnter(menuTriggerSubjects, 'button')"
                  (mouseleave)="onMouseLeave(menuTriggerSubjects, 'button')"
                >
                  <span mat-line>{{
                    news.subjects ? news.subjects[0].subject : ''
                  }}</span>
                </button>
                <mat-menu #menuAuditSubjects="matMenu" overlapTrigger="true">
                  <div
                    (mouseenter)="onMouseEnter(menuTriggerSubjects, 'menu')"
                    (mouseleave)="onMouseLeave(menuTriggerSubjects, 'menu')"
                  >
                    <button
                      class="no-action"
                      mat-menu-item
                      *ngFor="let subject of news.subjects"
                    >
                      {{ subject.subject }}
                    </button>
                  </div>
                </mat-menu>
              </div>
            </div>
            <div
              mat-line
              class="audit-actions"
              *ngIf="
                routing.isNewsaudit() &&
                !(
                  params.newstype === 'Flagged' ||
                  params.newstype === 'Dismissed'
                )
              "
              [class.transparent]="!news.visible"
            >
              <div
                mat-icon-button
                id="audit-action-add-flag"
                class="audit"
                matTooltip="Flag"
                matTooltipPosition="below"
                (click)="selectNews(news, 'audit')"
                *ngIf="
                  params.newstype !== 'Flagged' &&
                  params.newstype !== 'Dismissed'
                "
              >
                <mat-icon>flag</mat-icon>
              </div>
              <div
                mat-icon-button
                id="audit-action-add-dismiss"
                class="dismiss"
                matTooltip="Dismiss"
                matTooltipPosition="below"
                (click)="selectNews(news, 'dismiss')"
                *ngIf="
                  params.newstype !== 'Flagged' &&
                  params.newstype !== 'Dismissed'
                "
              >
                <mat-icon>remove_circle</mat-icon>
              </div>
              <div
                mat-icon-button
                id="audit-action-add-bookmark"
                class="bookmark"
                matTooltip="{{
                  !iBookmark(news.id) ? 'Bookmark' : 'Unbookmark'
                }}"
                matTooltipPosition="below"
                (click)="toggleBookmark(news.id)"
                *ngIf="
                  params.newstype !== 'Flagged' &&
                  params.newstype !== 'Dismissed'
                "
              >
                <mat-icon [class.starred]="iBookmark(news.id)"
                  >bookmark</mat-icon
                >
              </div>
            </div>
            <div
              mat-line
              class="audit-actions"
              *ngIf="
                routing.isNewsaudit() &&
                (params.newstype === 'Flagged' ||
                  params.newstype === 'Dismissed')
              "
            >
              <div
                mat-icon-button
                id="audit-action-resolve-case"
                class="audit"
                matTooltip="Resolve case"
                matTooltipPosition="below"
                (click)="selectNews(news, 'resolve')"
                *ngIf="
                  params.newstype === 'Flagged' && news.resolved === 'Opened'
                "
              >
                <mat-icon>assignment_turned_in</mat-icon>
              </div>
              <div
                mat-icon-button
                class="audit"
                id="audit-action-check-resolved-case"
                matTooltip="Check resolved case"
                matTooltipPosition="below"
                (click)="selectNews(news, 'check')"
                *ngIf="
                  params.newstype === 'Flagged' && news.resolved === 'Resolved'
                "
              >
                <mat-icon>assignment_returned</mat-icon>
              </div>
              <div
                mat-icon-button
                class="dismiss"
                id="audit-action-dismiss"
                matTooltip="Dismiss"
                matTooltipPosition="below"
                (click)="selectNews(news, 'dismiss')"
                *ngIf="
                  params.newstype !== 'Flagged' &&
                  params.newstype !== 'Dismissed'
                "
              >
                <mat-icon>remove_circle</mat-icon>
              </div>
              <div
                mat-icon-button
                class="dismiss"
                id="audit-action-check-dismissed-case"
                matTooltip="Check dismissed case"
                matTooltipPosition="below"
                (click)="selectNews(news, 'check')"
                *ngIf="params.newstype === 'Dismissed'"
              >
                <mat-icon>assignment_returned</mat-icon>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="scroload" *ngIf="loadnews === news.id">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
    </mat-list-item>
  </ng-container>
</mat-list>
